import styled from 'styled-components';
import { Box, mediaQueries } from '@lce/slice';
import { SafeImage } from '../../ui/SafeImage';
import { BannerLink } from '../../ui';

interface IImageBannerStyleProps {
  fullWidth?: boolean;
  backgroundColor?: string;
}

export const ImageBanner = styled(Box)<IImageBannerStyleProps>`
  background-color: ${({ theme, backgroundColor }) => backgroundColor ? backgroundColor : theme.colors.orange};
`;

export const Link = styled(BannerLink)`
  display: contents;
`;

export const DesktopImage = styled(SafeImage)<IImageBannerStyleProps>`
  display: none;

  ${mediaQueries[1]} {
    display: block;
    max-width: ${({ fullWidth }) => fullWidth ? 'inherit' : 'fit-content'};
  }
`;

export const MobileImage = styled(SafeImage)`
  display: block;

  ${mediaQueries[1]} {
    display: none;
  }
`;